//
// Generated class LayoutDocumentTemplate
//

/// <reference path="LayoutDocumentTemplate_ManagedObject.ts" />

class LayoutDocumentTemplate extends LayoutDocumentTemplate_ManagedObject
{

}
